/**
 * Transform Operation Grouping Rules
 * Handles grouping for drag, move, and transform operations
 */

import { Operation } from '@/shared/types/projectData';

export interface GroupingRule {
  opensGroup: 'transform' | 'edit' | 'organize' | 'navigate' | 'compound';
  name: (op: Operation) => string;
  mergeWindow?: number;
  canMerge?: boolean;
  mergeCondition?: (lastOp: Operation, newOp: Operation) => boolean;
}

export const transformRules: Record<string, GroupingRule> = {
  // Drag operations
  'drag-start': {
    opensGroup: 'transform',
    name: (op: Operation) => {
      const itemType = (op as Operation & { details?: { dragType?: string } }).details?.dragType || 'item';
      return `Start ${itemType} move`;
    },
    mergeWindow: 5000, // Extended for drag operations
    canMerge: true
  },

  'drag-complete': {
    opensGroup: 'transform',
    name: (op: Operation) => {
      const itemType = (op as Operation & { details?: { dragType?: string } }).details?.dragType || 'item';
      return `Move ${itemType}`;
    },
    mergeWindow: 5000,
    mergeCondition: (lastOp: Operation, newOp: Operation) => {
      // Group consecutive drags of same type
      return (lastOp as Operation & { details?: { dragType?: string } }).details?.dragType === (newOp as Operation & { details?: { dragType?: string } }).details?.dragType;
    }
  },

  'drag-cancel': {
    opensGroup: 'transform',
    name: () => 'Cancel drag',
    mergeWindow: 1000
  },

  // Move operations
  'move': {
    opensGroup: 'transform',
    name: () => 'Move item',
    canMerge: false
  }
};
